import { styled } from '@mui/material/styles'
import { Modal } from 'eezy-components'

export const StyledModal = styled(Modal)`
  & .MuiPaper-root {
    padding: 0;
  }
`
